var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsulin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insulin_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".insulin_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "insulin_svg__st0",
    d: "M110.4 109V57.6c0-3.2-2.6-5.7-5.7-5.7h-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "insulin_svg__st0",
    d: "M74.9 109V57.6c0-3.2 2.6-5.7 5.7-5.7h3.6V38.6c0-2.7 2.2-4.8 4.8-4.8h7.2c2.7 0 4.8 2.2 4.8 4.8v13.2M92.7 33.8V12M65.1 116.4h55.1M110.4 72.5h-11M110.4 84.1h-11M110.4 95.8h-11M85.1 116.4V136M100.2 116.4V136M78.3 136h28.8M49.9 136H33.2c-3 0-5.4-2.4-5.4-5.4V87.8c0-4.6 3.7-8.3 8.3-8.3h11c4.6 0 8.3 3.7 8.3 8.3v42.8c0 2.9-2.5 5.4-5.5 5.4zM34.6 69.4v10.1M41.6 69.4H30.8c-1.7 0-3.1-1.4-3.1-3.1V62c0-1.7 1.4-3.1 3.1-3.1h21.5c1.7 0 3.1 1.4 3.1 3.1v4.3c0 1.7-1.4 3.1-3.1 3.1h-3.8v10.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-icon-secondary)",
    d: "M33.8 107.7h15.6V130H33.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-icon-primary)",
    d: "M80.9 57.9V109h6.2V57.9h-2.8z"
  })));
}
export default SvgInsulin;